import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faSave,
  faCancel,
  faCheck,
  faXmark,
  faFileLines,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
const EditableTable = ({
  headers,
  rows,
  editRowId,
  editedData,
  handleEdit,
  handleSave,
  handleCancel,
  handleChange,
  editableFields,
  handleLog,
  hideChangeLog,
  handleView,
}) => {
  return (
    <div className="tableContainer">
      <table className="table text-xs w-[88vw]" role="table">
        <thead className="stickyHeader bg-[var(--mainCol)] text-white">
          <tr>
            {headers?.map((header, index) => (
              <th
                className="p-1 text-left border"
                key={index}
                style={{
                  minWidth: (header === "msg" || header === "message" || header === "responseMsg" || header === "response_msg") ? "150px" : undefined
                }}
              >
                {header.toUpperCase()}
              </th>
            ))}
            <th
              style={{ background: "var(--mainCol)" }}
              className="p-1 text-left border stickyActionColumn z-100"
            >
              ACTION
            </th>
          </tr>
        </thead>
        <tbody>
          {rows?.map((row) => (
            <tr key={row.id}>
              {headers.map((header) => (
                <td
                  key={header}
                  className="p-3 border"
                  style={{
                    minWidth: (header === "msg" || header === "message" || header === "responseMsg" || header === "response_msg") ? "150px" : undefined
                  }}
                >
                  {editRowId === row.id && editableFields?.includes(header) ? (
                    header === "active" ||
                      header === "is_active" ||
                    header === "status" ||
                     header === "queryInProgress" ||
                    header === "is_read" ||
                    header === "is_Finshed" ||
                    header === "is_Start" ||
                    header === "queryResolve" ? (
                      <div className="cursor-pointer flex justify-center">
                        {editedData[header] === true && (
                          <FontAwesomeIcon
                            onClick={(e) => handleChange(e, header, true)}
                            color="var(--green_Main)"
                            icon={faCheck}
                          />
                        )}
                        {editedData[header] === false && (
                          <FontAwesomeIcon
                            onClick={(e) => handleChange(e, header, false)}
                            color="indianred"
                            icon={faXmark}
                          />
                        )}
                      </div>
                    ) : (
                      <input
                        type="text"
                        value={editedData[header] || ""}
                        onChange={(e) => handleChange(e, header)}
                        onKeyUp={(e) => e.key === "Enter" && handleSave()}
                        className="w-full p-1 border"
                      />
                    )
                  ) : row[header] === true ? (
                    <FontAwesomeIcon
                      className="ml-2"
                      color="var(--green_Main)"
                      icon={faCheck}
                    />
                  ) : row[header] === false ? (
                    <FontAwesomeIcon
                      className="ml-2"
                      color="indianred"
                      icon={faXmark}
                    />
                  ) : header === "UserId" || header === "userId" || header === "user_id" ? (
                    <Link
                      to={`/panel-user/${row[header]}`}
                      className="text-blue-600 hover:text-blue-800 hover:underline font-semibold"
                    >
                      {String(row[header] ?? "")}
                    </Link>
                  ) : (
                    (header === "msg" || header === "message" || header === "responseMsg" || header === "response_msg") && String(row[header]).length > 20
                      ? String(row[header]).substring(0, 20) + "..."
                      : String(row[header] ?? "")
                  )}
                </td>
              ))}
              <td className="p-2 border stickyActionColumn">
                {editRowId === row.id ? (
                  <div className="flex justify-center">
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="#67a97b"
                      onClick={handleSave}
                      icon={faSave}
                    />
                    <FontAwesomeIcon
                      className="p-2 cursor-pointer"
                      color="indianred"
                      onClick={handleCancel}
                      icon={faXmark}
                    />
                  </div>
                ) : (
                  <div className="flex justify-center z-100">
                    {handleView ? (
                      <FontAwesomeIcon
                        className="cursor-pointer"
                        onClick={() => handleView(row)}
                        icon={faEye}
                      />
                    ) : (
                      <FontAwesomeIcon
                        className="cursor-pointer"
                        onClick={() => handleEdit(row.id)}
                        icon={faPenToSquare}
                      />
                    )}
                    {!hideChangeLog && (
                      <FontAwesomeIcon
                        className="ml-2 cursor-pointer"
                        onClick={() => handleLog(row.id)}
                        icon={faFileLines}
                      />
                    )}
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default EditableTable;
